export const environment = {
    ambiente: 'sandbox',
    production: false,
    url: 'https://sandbox.e-brigada.com.br/api/',
    ws: 'https://ws.sandbox.e-brigada.com.br',
    iot: {
        servidor: 'sandbox.e-brigada.com.br',
        porta: 80,
        caminho: '/api/temperatura/medidor'
    },
    mercadoPagoKey: 'TEST-691a8cf3-1324-44ca-818e-2b154d45e875',
	randon: {
		appId: 'cdd28401-2481-4725-817e-98760bd3f466',
		tenantId: '812a6bd0-5829-4196-b2be-d0580b7bd0cb',
		secret: null,
		redirectUrl: 'http://localhost',
        androidUrl: 'msauth://br.com.ebrigada/bkXMNfg8gUQyl%2BcvGRzMDg9z8W0%3D'
	},
    jirau: {
		appId: '66f0e593-991f-4f68-978c-1a65a3cbdab8',
		tenantId: '055d8313-799e-4f7a-be79-d12530adcf8b',
		secret: null,
		redirectUrl: 'http://localhost',
        androidUrl: 'msauth://br.com.ebrigada/bkXMNfg8gUQyl%2BcvGRzMDg9z8W0%3D'
	},
	alcance: {
		appId: '1a56f01c-7b29-4260-af17-769d5b7f4db9',
		tenantId: 'faf19864-aa33-4f59-a82b-f1dd92f726ed',
		secret: null,
		redirectUrl: 'http://localhost:8100',
        androidUrl: 'msauth://br.com.ebrigada/bkXMNfg8gUQyl%2BcvGRzMDg9z8W0%3D'
	}
};
